import { render, staticRenderFns } from "./BaseTwitterShare.vue?vue&type=template&id=0667817d&"
import script from "./BaseTwitterShare.vue?vue&type=script&lang=js&"
export * from "./BaseTwitterShare.vue?vue&type=script&lang=js&"
import style0 from "./BaseTwitterShare.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports